export var CoverRequestStatus;
(function (CoverRequestStatus) {
    CoverRequestStatus["Pending"] = "pending";
    CoverRequestStatus["Accepted"] = "accepted";
    CoverRequestStatus["Referred"] = "referred";
    CoverRequestStatus["Failed"] = "failed";
})(CoverRequestStatus || (CoverRequestStatus = {}));
